import type { FC } from "react"
import { useRef } from "react"

import { useRecoilState } from "recoil"

import { moveBoxPositionState } from "../../state/view"
import { Move } from "../Interactions/Move"

export const MoveBox: FC = () => {
  const [moveBoxPosition, setMoveBoxPosition] =
    useRecoilState(moveBoxPositionState)
  const draggableRef = useRef(null)

  return (
    <Move
      nodeRef={draggableRef}
      onDrag={setMoveBoxPosition}
      position={moveBoxPosition}
    >
      <rect width="100%" height="100%" fill="transparent" ref={draggableRef} />
    </Move>
  )
}
